const styles = {
  videoHeading: {
    fontSize: "16px",
    margin: "20px 8px 8px",
  },
  video: {
    margin: "16px 40px 0",
  },
  videoDescription: {
    fontSize: "14px",
    margin: "4px 40px",
  },
};

export default styles;
